<template>
  <div class="newcomer-container" @click="$router.push({ name: 'Newcomer' })">
    <div class="left">
      <div class="title">新人下单会场</div>
      <div class="subtitle">精选爆款 下单无忧</div>
      <div class="btn">GO<Icon name="arrow" /></div>
    </div>
    <div class="right">
      <div class="swiper-wrapper">
        <Swipe :show-indicators="false" :autoplay="3000">
          <SwipeItem v-for="(item, index) in list" :key="'greegoods-' + index">
            <div
              class="img-wrapper"
              :style="{ backgroundImage: 'url(' + item + ')' }"
            ></div>
          </SwipeItem>
        </Swipe>
      </div>
    </div>
  </div>
</template>

<script>
import { getNewcomerList } from '@/api/newcomer'
import { Swipe, SwipeItem, Icon } from 'vant'
export default {
  components: { Swipe, SwipeItem, Icon },
  data() {
    return {
      list: [],
    }
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      getNewcomerList().then((res) => {
        const list = []
        res.data.forEach((item) => {
          if (Array.isArray(item.themeGoodsList)) {
            const goodList = item.themeGoodsList.map((_item) => _item.goodsImage)
            list.push(...goodList)
          }
          if (Array.isArray(item.themeBrandList)) {
            item.themeBrandList.forEach((_item) => {
              if (Array.isArray(_item.brandGoodsList)) {
                const goodList = _item.brandGoodsList.map(
                  (__item) => __item.goodsImage
                )
                list.push(...goodList)
              }
            })
          }
          if (Array.isArray(item.themeSuitH5List)) {
            item.themeSuitH5List.forEach((_item) => {
              if (Array.isArray(_item.themeGoodsList)) {
                const goodList = _item.themeGoodsList.map(
                  (__item) => __item.goodsImage
                )
                list.push(...goodList)
              }
            })
          }
        })
        this.list = list.slice(0, 5)
      })
    },
  },
}
</script>

<style lang="less" scoped>
.newcomer-container {
  display: flex;
  justify-content: space-between;
  background: #ffffff;
  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.1);
  border-radius: 16px;
  padding: 20px 20px 22px;
  margin-top: 20px;
  .left {
    .title {
      font-size: 28px;
      font-weight: 600;
      color: #000000;
      line-height: 40px;
    }
    .subtitle {
      font-size: 20px;
      font-weight: 400;
      color: #aeaeae;
      line-height: 28px;
    }
    .btn {
      margin-top: 10px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 34px;
      height: 34px;
      width: 74px;
      font-size: 18px;
      font-weight: 600;
      color: #ffffff;
      line-height: 18px;
      background-color: #f7b500;
      .van-icon {
        font-size: 20px;
        line-height: 20px;
      }
    }
  }
  .right {
    padding-top: 22px;
    .swiper-wrapper {
      width: 94px;
      height: 94px;
      .van-swipe {
        height: 100%;
      }
      .img-wrapper {
        width: 100%;
        height: 100%;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center center;
      }
    }
  }
}
</style>